import React from 'react';
import { Stack, Loader } from '@chaser/components';
import styles from './FullLayoutLoader.module.scss';

const FullLayoutLoader = () => {
  return (
    <Stack alignItems="center" justifyContent="center" className={styles.fullLayoutLoader}>
      <Loader size={30} />
    </Stack>
  );
};

export default FullLayoutLoader;
